import { Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router'
import { AlzaLanding } from 'alza-core'
import { ALZA_BASE_PATH, SMARCEL_BASE_PATH } from '../config/basePaths'
import { SmarcelLanding } from './landings'

export const App = () => (
  <BrowserRouter>
    <Routes>
      <Route
        element={
          <Suspense fallback={null}>
            <SmarcelLanding basePath={SMARCEL_BASE_PATH} />
          </Suspense>
        }
        path={`${SMARCEL_BASE_PATH}/*`}
      />
      <Route element={<AlzaLanding basePath={ALZA_BASE_PATH} />} path="/*" />
    </Routes>
  </BrowserRouter>
)

App.displayName = 'App'
